import { render } from "./FileDataWithTumbnail.vue?vue&type=template&id=44a4fc04"
import script from "./FileDataWithTumbnail.vue?vue&type=script&lang=js"
export * from "./FileDataWithTumbnail.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__